import { Breakpoints } from "core/constants";
import styled from "styled-components";

import LoaderSVG from "@/animations/loader/loading-animation-black.svg?react";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  font-family: Nunito-Sans;
  background-color: ${({ theme }) => theme?.colors?.gray1};
`;

export const Logo = styled.img`
  position: absolute;
  top: 20px;
  left: 20px;
  height: 80px;
`;

export const Loader = styled(LoaderSVG)`
  width: 100px;
  height: 100px;

  @media screen and (max-width: ${Breakpoints.mobile}px) {
    width: 60px;
    height: 60px;
  }

  circle {
    stroke: ${({ theme, stroke }) => stroke ?? theme?.colors?.primary.default};
  }
`;
